import { useEffect, useState } from "react";
import ApiService from "../../core/service/ApiService";
import { t } from "i18next";
import { Select } from "antd";
import { useUser } from "../../core/context/UserContext";

export default function UserSelectList({ showEntitlementConfirmUser = false, showSelf = false, ...props }) {
    const [users, setUsers] = useState([]);
    const { firmSettings, user } = useUser()

    const getUsers = async () => {
        let _users = []
        if (showEntitlementConfirmUser) {
            const res2 = await ApiService.Entitlement.GetEntitlementConfirmUsers();
            if (res2.success) {
                _users = res2.data;
            }
        }

        const res = await ApiService.User.GetUserList({ Enable: null, Entitlement: true });
        if (res.success) {
            _users = res.data;
        }

        setUsers(_users)
    }

    useEffect(() => {
        getUsers()
    }, [])


    return (
        <Select
            style={{ width: 200 }}
            size={'small'}
            placeholder={t('Select User')}
            showSearch={true}
            filterOption={(input, option) => {
                return option.children.toString().toLocaleLowerCase(firmSettings?.locale).includes(input.toLocaleLowerCase(firmSettings?.locale))
            }}
            {...props}
        >
            {
                users.map(x => (
                    <Select.Option value={x.id} key={x.id}>
                        {x.name}
                    </Select.Option>
                ))
            }
        </Select>
    )
}